<template>
  <NuxtLayout>
    <v-container v-if="showImage" fill-height fluid>
      <v-row justify="center" align="center" class="error-container h-100">
        <v-col  cols="12" class="center-vertically text-center">
          <div >
            <img
              loading="lazy"
              :src="imageSrc"
              alt="Page not found image"
              :width="width > 1280 ? '100%' : '80%'"
              :height="width > 1280 ? '500px' : '400px'"
            />
          </div>

          <v-btn v-if="!(error?.statusCode  === 500)" @click="clearError">
            Kaldığın Yerden Devam Et 
          </v-btn>
        </v-col>
        <v-col v-if="error?.statusCode === 500" cols="12" class="d-flex justify-center align-center font-weight-bold custom-color ">
          Sitemizde bakım çalışması yapıyoruz
        </v-col>
        <v-col v-if="error?.statusCode  === 500" cols="12" class="d-flex justify-center align-center pb-16 custom-color ">
          Bu süreçte kısa bir ara vereceğiz. Anlayışınız için teşekkür eder, en kısa sürede tekrar hizmetinizde olacağız.
        </v-col>

      </v-row>
    </v-container>
  </NuxtLayout>
</template>

<script setup lang="ts">

import { useErrorStore } from './stores/error';
import { useDisplay } from 'vuetify'


const props = defineProps({
  error: Object
})
const { width } = useDisplay();
const route = useRoute()
const errorStore = useErrorStore();


const clearError = () => {
  errorStore.clearError();
  errorStore.setIsErrorPageOpen(false);
};

const error = useError()
const showImage = ref(false)
const imageSrc = ref('');

onMounted(() => {
  if ( error.value?.statusCode === 500) {
    import('~/assets/error.avif').then((module) => {
      imageSrc.value = module.default;
    })
  }else if(error.value?.statusCode === 404) {
    import('@/assets/dontFind.avif').then((module) => {
      imageSrc.value = module.default;
    })
  }else{
    import('@/assets/dontFind.avif').then((module) => {
      imageSrc.value = module.default;
    })
  }
  showImage.value = true;
})
</script>


<style scoped>
.custom-color {
  color:  var(--color-cookie-blue) !important;
}
.error-container {
  height: 100%;
  padding: 60px 0 120px 0;
}

.backToHomeButton {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.center-vertically {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.custom-background-white {
  background-color: var(--color-text-white);
}
</style>
